export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_STREET = 'street_number'
export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_ROUTE = 'route'
export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_SUBURB = 'locality'
export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_STATE =
  'administrative_area_level_1'
export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_POSTCODE = 'postal_code'
export const GOOGLE_MAP_ADDRESS_COMPONENT_TYPE_COUNTRY = 'country'
